import React from "react"

import UtilizationRangeFilter from "../UtilizationRangeFilter"

const UtilizationPercentSquare = cellData => {
  let squareClass, roundedValue

  for (const filter of UtilizationRangeFilter.filterRanges) {
    if (cellData >= filter[1][0] && cellData <= filter[1][1])
      squareClass = filter[0]
  }

  if (cellData > 0 && cellData < 1) {
    // Value should not be rounded to 0, since that would suggest never used.
    roundedValue = 1
  } else if (cellData > 99 && cellData < 100) {
    // Value should not be rounded to 100, since that would suggest always used.
    roundedValue = 99
  } else {
    roundedValue = Math.round(cellData)
  }

  return (
    <div className="avg-usage">
      <span className={`utilization-range-square ${squareClass}`} />
      {roundedValue}%
    </div>
  )
}

export default UtilizationPercentSquare
